import userManager from 'Oidc/userManager'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { instance } from 'Services/instance'
import { ToastsErrorBottomLeft, ToastSuccessBottomLeft } from 'Utils/toastService'
import Icon from 'Components/Icon'
import { useSettings } from 'Contexts/SettingsContext'
import Const from 'Utils/Consts';
import { deleteBasicData } from 'DataBase/BasicDataDB'
import CacheNames from 'Application/Common/Constants/CacheNames'

interface IProps {
    url: string
    title: string
    fileName: string
    className?: string
    mainClassName?: string
    style?: any
    icon?: string
    disabled?: boolean
}

const FileDownloader = (props: IProps) => {
    const { t } = useTranslation();
    const [loading, setLoading] = React.useState<boolean>(false);
    const dispatch = useDispatch()
    const { settings } = useSettings()
    // const fakeUser = settings?.REACT_APP_FAKE_USER != undefined ? settings?.REACT_APP_FAKE_USER : Const.env.REACT_APP_FAKE_USER

    const handleDownload = async () => {
        setLoading(true)
        try {
            await instance.get(props.url, {
                responseType: 'blob',
                timeout: 120000,
                skipToast: true
            }).then(async (res) => {
                if (res.status === 200) {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = props.fileName;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);

                    setLoading(false)
                }
            }).catch(async (error) => {
                let statusCode = error.response.status
                let errors = [];

                if (statusCode === 401) {
                    userManager.removeUser()
                    localStorage.clear()
                    userManager.clearStaleState()
                    userManager.signinRedirect({ state: { path: window.location.pathname }, prompt: 'login' })
                    errors.push(t('LOGIN_ERROR_MESSAGE'));
                }
                else if (statusCode === 403) {
                    errors.push(t('AUTHORIZATION_ERROR_MESSAGE'));
                } else if (statusCode === 400 && error.response.data) {
                    const text = await error?.response?.data?.text()
                    errors.push(...JSON.parse(text));
                } else {
                    errors.push(t("OPERATION_ERROR_MESSAGE"));
                }

                ToastsErrorBottomLeft(errors)
                setLoading(false)
            })
        } catch (error) {
            console.log("error11", error)
            console.error('There has been a problem with your fetch operation:', error);
            setLoading(false)
        }
    };

    return (
        <button
            onClick={handleDownload}
            style={props.style}
            disabled={props.disabled}
            className="btn btn-outline-primary btn-lg flex gap-1 items-center justify-center">
            <Icon name="document-download" className="w-6 h-6" />
            {props.title}
        </button>
    );
};

export default FileDownloader;